import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/customer/add/tenant.customer.assign.mutation.gql"
import type {
  TenantCustomerAssignMutation,
  TenantCustomerAssignMutationVariables,
} from "@/v2-backoffice-client/tenant/customer/add/__types__/tenant.customer.assign.mutation"

type Options = MutationHookOptions<
  TenantCustomerAssignMutation,
  TenantCustomerAssignMutationVariables
>

export function useTenantCustomerAssignMutation(options?: Options) {
  return useMutation<
    TenantCustomerAssignMutation,
    TenantCustomerAssignMutationVariables
  >(mutation, options)
}
